import Global from '../shared/global';

const $ = jQuery.noConflict();

'use strict';
const BookingReorder = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.reorder();
		$(document).ajaxStop(function() {
			BookingReorder.reorder();
		});
	},
	reorder() {
		const buttons = document.querySelectorAll('.js-single-view-reorder');
		if (!buttons) {
			return;
		}

		const reorderBooking = function() {
			const dataId = this.getAttribute('data-id');
			const data = {
				action: 'reorder_booking',
				orderId: dataId
			};
			BookingReorder.ajaxFunc(data);
		};

		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener('click', reorderBooking);
		}
	},
	// ajax function
	ajaxFunc: function(data) {
		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			data: data,
			success: (response) => {
				if (response.success === true) {
					const data = response.data.data;
					const stepsPage = response.data.steps_page;
					Global.setCookie('address', data.address);
					Global.setCookie('cleaningType', data.cleaningType);
					Global.setCookie('activeBedroomObj', data.bedroom);
					Global.setCookie('activeBathroomObj', data.bathroom);
					Global.setCookie('multiDates', data.multiDates);
					Global.setCookie('frequency', data.frequency);
					Global.setCookie('selectedOneTimeDate', ''); // user must select new date for new order
					Global.setCookie('selectedTime', data.time);
					Global.setCookie('addressInfo', data.addressInfo);
					Global.setCookie('extraPriceTotal', data.extras);
					Global.setCookie('activeBedroom', data.activeBedroom);
					Global.setCookie('activeBathroom', data.activeBathroom);
					setTimeout(function() {
						location.href = stepsPage;
					}, 500);
				} else {
					alert('Something went wrong, please try again later!');
				}
			}
		});
	},
};

export default BookingReorder;
